'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from '@byway/icons';
import NumberFlow from '@number-flow/react';
import { useLocale, useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { TripPriceSkeleton } from '~/components/TripOverview/booking/TripPriceSkeleton';
import styles from './StickyFooter.module.css';
import type { StickyFooterProps } from './StickyFooter.types';
export function StickyFooter(t0) {
  const $ = _c(54);
  const {
    dateRange,
    travellerCount,
    price,
    currency: t1,
    priceLabel: t2,
    PriceRow,
    ctaLabel: t3,
    onCtaClick,
    ctaUaClick,
    isCtaDisabled: t4,
    onPriceClick,
    onDateClick,
    onTravellersClick,
    isSummaryDisabled: t5,
    className
  } = t0;
  const currency = t1 === undefined ? "GBP" : t1;
  const priceLabel = t2 === undefined ? "person" : t2;
  const ctaLabel = t3 === undefined ? "Continue" : t3;
  const isCtaDisabled = t4 === undefined ? false : t4;
  const isSummaryDisabled = t5 === undefined ? false : t5;
  const t = useTranslations("journey");
  const locale = useLocale();
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== PriceRow || $[1] !== className || $[2] !== currency || $[3] !== dateRange || $[4] !== isSummaryDisabled || $[5] !== locale || $[6] !== onDateClick || $[7] !== onPriceClick || $[8] !== onTravellersClick || $[9] !== price || $[10] !== priceLabel || $[11] !== t || $[12] !== travellerCount) {
    const travellerText = t("sticky_footer_traveller_count", {
      count: travellerCount
    });
    const showPriceSkeleton = price === undefined;
    const isStaticSummary = !onDateClick && !onTravellersClick;
    let t12;
    if ($[19] !== currency || $[20] !== locale || $[21] !== price || $[22] !== showPriceSkeleton) {
      t12 = <span className={styles.priceValue}>{showPriceSkeleton ? <TripPriceSkeleton /> : <NumberFlow value={price} locales={locale} format={{
          style: "currency",
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true,
          currencyDisplay: "symbol"
        }} />}</span>;
      $[19] = currency;
      $[20] = locale;
      $[21] = price;
      $[22] = showPriceSkeleton;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    const priceValue = t12;
    const t13 = `${styles.aside} ${className ?? ""}`;
    if ($[24] !== t13) {
      t9 = t13.trim();
      $[24] = t13;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    if ($[26] !== t) {
      t10 = t("sticky_footer_aria_label");
      $[26] = t;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    t11 = "StickyFooter";
    t6 = styles.info;
    let t14;
    if ($[28] !== PriceRow || $[29] !== priceValue) {
      t14 = PriceRow ? <PriceRow>{priceValue}</PriceRow> : priceValue;
      $[28] = PriceRow;
      $[29] = priceValue;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    let t15;
    if ($[31] !== priceLabel) {
      t15 = <span className={styles.priceSuffix}> {priceLabel}</span>;
      $[31] = priceLabel;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    if ($[33] !== onPriceClick || $[34] !== showPriceSkeleton || $[35] !== t14 || $[36] !== t15) {
      t7 = <button type="button" className={styles.priceButton} onClick={onPriceClick} disabled={showPriceSkeleton}>{t14}{t15}</button>;
      $[33] = onPriceClick;
      $[34] = showPriceSkeleton;
      $[35] = t14;
      $[36] = t15;
      $[37] = t7;
    } else {
      t7 = $[37];
    }
    t8 = isStaticSummary ? <p className={styles.tags}>{dateRange && <span className={styles.tag}>{dateRange}</span>}<span className={styles.tag}>{travellerText}</span></p> : <p className={styles.summary}>{dateRange && <><button type="button" className={styles.summaryItem} onClick={onDateClick} disabled={isSummaryDisabled} aria-label={t("sticky_edit_dates_aria_label", {
          dates: dateRange
        })}>{dateRange}</button>{" \u2022 "}</>}{onTravellersClick ? <button type="button" className={styles.summaryItem} onClick={onTravellersClick} disabled={isSummaryDisabled} aria-label={t("sticky_edit_travellers_aria_label", {
        travellers: travellerText
      })}>{travellerText}</button> : <span>{travellerText}</span>}</p>;
    $[0] = PriceRow;
    $[1] = className;
    $[2] = currency;
    $[3] = dateRange;
    $[4] = isSummaryDisabled;
    $[5] = locale;
    $[6] = onDateClick;
    $[7] = onPriceClick;
    $[8] = onTravellersClick;
    $[9] = price;
    $[10] = priceLabel;
    $[11] = t;
    $[12] = travellerCount;
    $[13] = t10;
    $[14] = t11;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t12;
  if ($[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
    t12 = <div className={t6}>{t7}{t8}</div>;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ArrowRight decorative={true} isInline={true} size="small" />;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== ctaLabel || $[44] !== ctaUaClick || $[45] !== isCtaDisabled || $[46] !== onCtaClick) {
    t14 = <Button variant="primary" size="fullWidth" isPillShape={true} onPress={onCtaClick} isDisabled={isCtaDisabled} data-ua-click={ctaUaClick}>{ctaLabel} {t13}</Button>;
    $[43] = ctaLabel;
    $[44] = ctaUaClick;
    $[45] = isCtaDisabled;
    $[46] = onCtaClick;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t14 || $[52] !== t9) {
    t15 = <aside className={t9} aria-label={t10} data-test-id={t11}>{t12}{t14}</aside>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t12;
    $[51] = t14;
    $[52] = t9;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  return t15;
}